import * as FooterMobile from './FooterMobile.css';
export default {
    FooterMobile
};
